import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteUserFromOrganizationMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  orgId: Types.Scalars['uuid']['input'];
}>;


export type DeleteUserFromOrganizationMutation = { __typename?: 'mutation_root', delete_organizations_users?: { __typename?: 'organizations_users_mutation_response', affected_rows: number } | null, update_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: string, organization_id?: any | null }> } | null };


export const DeleteUserFromOrganizationDocument = gql`
    mutation deleteUserFromOrganization($userId: String!, $orgId: uuid!) {
  delete_organizations_users(
    where: {user_id: {_eq: $userId}, organization_id: {_eq: $orgId}}
  ) {
    affected_rows
  }
  update_users(
    where: {id: {_eq: $userId}, organization_id: {_eq: $orgId}}
    _set: {organization_id: null}
  ) {
    returning {
      id
      organization_id
    }
  }
}
    `;
export type DeleteUserFromOrganizationMutationFn = Apollo.MutationFunction<DeleteUserFromOrganizationMutation, DeleteUserFromOrganizationMutationVariables>;

/**
 * __useDeleteUserFromOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteUserFromOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserFromOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserFromOrganizationMutation, { data, loading, error }] = useDeleteUserFromOrganizationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useDeleteUserFromOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserFromOrganizationMutation, DeleteUserFromOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserFromOrganizationMutation, DeleteUserFromOrganizationMutationVariables>(DeleteUserFromOrganizationDocument, options);
      }
export type DeleteUserFromOrganizationMutationHookResult = ReturnType<typeof useDeleteUserFromOrganizationMutation>;
export type DeleteUserFromOrganizationMutationResult = Apollo.MutationResult<DeleteUserFromOrganizationMutation>;
export type DeleteUserFromOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteUserFromOrganizationMutation, DeleteUserFromOrganizationMutationVariables>;